'use strict';

function itemDetailCtrl($scope, toastr, managedItem, $q, $stateParams, $state, catalogVersion,
                        downloadFile, $filter, pathConstants, $http, $uibModal, changeStatusCatalog,
                        Approvals, profile, items, manageItemDetail,
                        HighlightId, itemDetailsListing, $rootScope, searchModule, globalFunc) {

  $scope.approvals = [];
  $scope.approvalFlowData = {};
  $scope.rejector = {};
  $scope.waiting_on_user = [];
  $scope.checkWaitingOn = checkWaitingOn;
  $scope.approveItem = approveItem;
  $scope.rejectItem = rejectItem;
  $scope.changeStatus = changeStatus;
  $scope.viewHistoryDetails = viewHistoryDetails;
  $scope.getItemListing = getItemListing;
  $scope.viewSingleItemDetails = viewSingleItemDetails;
  $scope.downloadImportCatalogCSV = downloadImportCatalogCSV;
  $scope.downloadImageFileZip = downloadImageFileZip;
  $scope.getImportCatalogCSVTitle = getImportCatalogCSVTitle;
  $scope.uploadImageFileModal = uploadImageFileModal;
  $scope.back = back;
  $scope.showColumn = showColumn;

  // Get Items Detail
  $scope.itemDetail = managedItem.data;
  $scope.status = $scope.itemDetail.import_status;
  $scope.requestor = {
    "_id": "",
    "display_name": $scope.itemDetail.created_by,
    "img_url": ""
  };

  $scope.columns = [
    {id: 'item_name', label: 'Item Name'},
    {id: 'description', label: 'Description'},
    {id: 'supplier.descr', label: 'Supplier'},
    {id: 'supplier_part_no', label: 'Supplier Part Number'},
    {id: 'tax.rate', label: 'Tax Rate'},
    {id: 'payment_term.descr', label: 'Payment Term'},
    {id: 'currency.code', label: 'Currency'},
    {id: 'unit_price', label: 'Unit Price'},
    {id: 'Uom.code', label: 'UOM'},
    {id: 'effective_at', label: 'Effective Date', type: 'date'},
    {id: 'expiry_at', label: 'Expiry Date', type: 'date'}
  ];
  $scope.storageKey = 'item-details-management-selected-columns';

  function showColumn(id){
    for (var i in $scope.columns) {
      if (id === $scope.columns[i].id) {
        if(!!$scope.columns[i].conditional){
          if($scope.status === $scope.columns[i].condition){
            return $scope.columns[i].selected;
          }
          if($scope.columns[i].condition instanceof Array){
            for(var j in $scope.columns[i].condition){
              if($scope.status === $scope.columns[i].condition[j]){
                return $scope.columns[i].selected;
              }
            }
          }
        }else{
          return $scope.columns[i].selected;
        }
      }
    }
  }

  function back() {

    var data = $scope.$parent.tabData;
    var statusPendingApproval = $scope.status;

    if($scope.status === 'PENDING'){
      statusPendingApproval = 'Pending Approval';
    }else if ($scope.status === 'DEACTIVATED'){
      statusPendingApproval = 'Inactive';
    }
    var tabData = globalFunc.findInArray(data[0].menu, 'heading', statusPendingApproval, true);

    if (!!$scope.itemDetail && !!$scope.itemDetail._id) {
      HighlightId.setId($scope.itemDetail._id);
    }
    $rootScope.$broadcast('loadSpecificTab', {tab: tabData});
  }

  // Import History
  // Get from another endpoint
  function getItemsVersion() {

    catalogVersion.get(
      {
        summary_id: managedItem.data._id
      },
      function (resource) {
        $scope.dataHistory = resource.content.data;
      },
      function (error) {

      }
    );
  }

  // Run the getItemsVersion function
  getItemsVersion();

  /**
   * Function to download the imported catalog csv
   * @param attachmentArray
   */
  function downloadImportCatalogCSV (attachmentArray) {
    _.forEach(attachmentArray, function(attachment){
      if(!!attachment.extension && attachment.extension.toLowerCase() === 'csv'){
        downloadFile.download({
          summary_id: attachment.import_summary_id,
          attachment_id: attachment._id
        }).$promise.then(
          function (resource) {
            var newUrl = $filter('format')(pathConstants.apiUrls.items.download, {
              summary_id: attachment.import_summary_id,
              attachment_id: attachment._id
            });
            window.open(newUrl, '_self');
            // Set a return here to break the forEach loop
            return true;
          }, function (error) {
            globalFunc.objectErrorMessage(error);
            // Set a return here to break the forEach loop
            return true;
          });
      }
    });
  }

  /**
   * Function to download the uploaded image file
   *
   * @param attachmentArray
   */
  function downloadImageFileZip (attachmentArray) {
    _.forEach(attachmentArray, function(attachment){
      if(!!attachment.extension && attachment.extension.toLowerCase() === 'zip'){
        downloadFile.download({
          summary_id: attachment.import_summary_id,
          attachment_id: attachment._id
        }).$promise.then(
          function (resource) {
            var newUrl = $filter('format')(pathConstants.apiUrls.items.download, {
              summary_id: attachment.import_summary_id,
              attachment_id: attachment._id
            });
            window.open(newUrl, '_self');
            // Set a return here to break the forEach loop
            return true;
          }, function (error) {
            globalFunc.objectErrorMessage(error);
            // Set a return here to break the forEach loop
            return true;
          });
      }
    });
  }

  /**
   * Function to get the import catalog title
   * @param attachmentArray
   * @returns {string}
   */
  function getImportCatalogCSVTitle(attachmentArray) {
    var title = '';
    _.forEach(attachmentArray, function(attachment){
      if(!!attachment.extension && attachment.extension.toLowerCase() === 'csv') {
        title = attachment.title;
        // Set a return here to break the forEach loop
        return true;
      }
    });
    return title;
  }

  /**
   * Function to upload the image file
   * @param summaryId
   */
  function uploadImageFileModal (summaryId) {
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/importImage.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        dataSummaryId: function () {
          return summaryId;
        }
      },
      controller: function (dataSummaryId, $scope, $uibModalInstance) {
        $scope.summaryId = angular.copy(dataSummaryId);
        $scope.cancel = cancel;
        $scope.importImage = importImage;

        function cancel () {
          $uibModalInstance.close();
        }

        // Save import image
        function importImage (images, summaryId) {
          if (!!images) {
            var fd = new FormData();
            fd.append('file', images);
            $http.post($filter('format')(pathConstants.apiUrls.items.imagesImport + summaryId), fd,
              {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
              })
              .then(function onSuccess () {
                toastr.success('Images successfully uploaded');
                getItemsVersion();
                $uibModalInstance.close();
              })
              .catch(function onError (error) {
                globalFunc.objectErrorMessage(error);
              });
          } else {
            toastr.error('No file chosen');
          }
        }
      }
    });
  }

  function viewHistoryDetails(summaryId, dataHistory, itemDetail, status){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/historyDetails.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        dataSummaryId: function () {
          return summaryId;
        },
        dataHistory: function() {
          return dataHistory;
        },
        itemDetail: function() {
          return itemDetail;
        },
        status: function() {
          return status;
        }
      },
      controller: function (dataSummaryId, $scope, $uibModalInstance,
                            viewHistoryDetails, dataHistory, itemDetail, status) {
        $scope.submitCatalog = submitCatalog;
        $scope.dataHistory = dataHistory;
        $scope.itemDetail = itemDetail;
        $scope.status = status;

        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        function submitCatalog(){
          changeStatusCatalog.put(
            {
              status: 'submit',
              id: dataSummaryId
            },
            function (resource) {
              toastr.success('Catalog submitted');
              $uibModalInstance.close();
              for(var i = 0; i < $scope.dataHistory.length; i++){
                if($scope.dataHistory[i]._id === resource.content.data._id){
                  $scope.dataHistory[i].import_status = resource.content.data.import_status;
                }
                if($scope.dataHistory[i]._id === $scope.itemDetail._id){
                  $scope.status = resource.content.data.import_status;
                }
              }
            },
            function (error) {
              toastr.error('Catalog submit failed');
            }
          );
        }

        viewHistoryDetails.get(
          {
            summary_id: dataSummaryId
          },
          function(resource){
            $scope.itemHistory = resource.content.data;
          },
          function(){
            toastr.error('Unable to view history detail');
          }
        )
      }
    });
  }

  /**
   *  Function to call endpoint to list item details based on status
   *  @params status: 10 New, 11 Updated, 12 Deleted, 13 Total
   */

  function getItemListing(status) {

    $scope.showItemDetails = true;
    $scope.itemDetailsStatus = status;
    /**
     * If selected status is not get total items listing
     */
    if(status !== 13){
      searchModule.get(
        {
          module: 'catalog-details',
          offset: 20,
          'criteria[import_summary_id]': $scope.itemDetail._id,
          'criteria[data_status]': status,
          criteria_operator: 'and'
        },
        function (resource) {
          $scope.itemDetailService = searchModule;
          $scope.embeddedParams = {
            module: 'catalog-details',
            offset: 20,
            'criteria[import_summary_id]': $scope.itemDetail._id,
            'criteria[data_status]': status,
            criteria_operator: 'and'
          };
          $scope.itemDetailsList = resource.content.data;
          $scope.itemDetailsMeta = resource.content.meta;
          $scope.itemDetailsLoaded = true;
          switch (status) {
            case 10:
              $scope.itemDetailTitle = 'New/Latest';
              break;
            case 11:
              $scope.itemDetailTitle = 'Updated';
              break;
            case 12:
              $scope.itemDetailTitle = 'Deleted';
              break;
            case 13:
              $scope.itemDetailTitle = 'Total';
              break;
          }
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
    /**
     * If selected status is get total items listing
     */
    else{
      searchModule.get(
        {
          module: 'catalog-details',
          offset: 20,
          'criteria[import_summary_id]': $scope.itemDetail._id,
          'criteria[data_status][0]': 10,
          'criteria[data_status][1]': 11,
          'criteria[data_status][2]': 14,
          criteria_operator: 'and'
        },
        function (resource) {
          $scope.itemDetailService = searchModule;
          $scope.embeddedParams = {
            module: 'catalog-details',
            offset: 20,
            'criteria[import_summary_id]': $scope.itemDetail._id,
            'criteria[data_status][0]': 10,
            'criteria[data_status][1]': 11,
            'criteria[data_status][2]': 14,
            criteria_operator: 'and'
          };
          $scope.itemDetailsList = resource.content.data;
          $scope.itemDetailsMeta = resource.content.meta;
          $scope.itemDetailsLoaded = true;
          switch (status) {
            case 10:
              $scope.itemDetailTitle = 'New/Latest';
              break;
            case 11:
              $scope.itemDetailTitle = 'Updated';
              break;
            case 12:
              $scope.itemDetailTitle = 'Deleted';
              break;
            case 13:
              $scope.itemDetailTitle = 'Total';
              break;
          }
        },
        function (error) {
          globalFunc.objectErrorMessage(error);
        }
      );
    }
  }

  /**
   *  Receive broadcast for updated embedded pagination data to update on controller side
   */
  $scope.$on('updateEmbeddedPagination', function(events, content){
    if(!!content && !!content.data)
    $scope.itemDetailsList = content.data;
  });

  function viewSingleItemDetails(data){
    var modalInstance = $uibModal.open({
      templateUrl: 'app/items/details/singleItemDetails.html',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        data: function(){
          return data;
        }
      },
      controller: function ($scope, $uibModalInstance, data, singleItemDetails) {
        $scope.cancel = function () {
          $uibModalInstance.close();
        };

        singleItemDetails.get(
          {
            summary_id: data.import_summary_id,
            import_item_id: data._id
          },
          function(resource){
            $scope.singleItemDetail = resource.content.data;
          },
          function(){
            toastr.error('Unable to view item detail');
          }
        )
      }
    });
  }

  // Change Status of the catalog
  function changeStatus(status, summaryId) {
    changeStatusCatalog.put(
      {
        status: status,
        id: summaryId
      },
      function () {
        toastr.success('Successfully changed status of catalog');
        HighlightId.setId(summaryId);
        if(status === 'activate' || status === 'deactivate' || status === 'submit' || status === 'cancel')
          $state.go('main.user.items.manageCatalog', {
            'status'    : 'pending',
            'order_by'  : 'updated_at',
            'order'     : 0
          });
        else
          $state.go('main.user.items.manageCatalog', {'status': status});
      },
      function (error) {
        globalFunc.objectErrorMessage(error);
      }
    );
  }

  // Approval Flow Data
  function loadApprovalFlow() {

    if (!$scope.itemDetail || !$scope.itemDetail.approval_id) {
      $scope.approvals = [];
    }

    Approvals.get(
      {
        id: $scope.itemDetail.approval_id
      },
      function (resource) {
        if (!!resource && !!resource.content && !!resource.content.data) {
          $scope.approvals = resource.content.data;
          $scope.requestor.display_name = resource.content.data.requested_by.display_name;
          if ($scope.status.toLowerCase() === 'pending') {
            $scope.approvalFlowData = resource.content.data;
            globalFunc.getWaitingOnUser(resource.content.data, $scope.waiting_on_user);
          }
          else if($scope.status.toLowerCase() === 'rejected'){
            for(var i in $scope.approvals){
              if(!!$scope.approvals[i].step_status && $scope.approvals[i].step_status.toLowerCase() === 'rejected'){
                $scope.rejector = $scope.approvals[i].rejectedRoles[0];
              }
            }
          }
        } else {
          $scope.approvals = [];
        }
      },
      function () {
        $scope.approvals = [];
      });
  }

  // If the import status is pending approved
  // Run loadApprovalFlow function
  if ($scope.status.toLowerCase()=== 'pending' || $scope.status.toLowerCase()=== 'rejected') {
    loadApprovalFlow();
  }

  //check user waiting on
  function checkWaitingOn() {
    var find_user = _.find($scope.waiting_on_user, function (approver) {
      return (approver._id == profile._id);
    });

    if (find_user != undefined) {
      return true;
    }

    return false;
  }

  // Approve Item
  function approveItem() {
    items.approve(
      {
        approval_id: $scope.itemDetail.approval_id,
        status: 'approve'
      },
      {},
      function () {
        toastr.success('You have approved this catalog.');

        // Get the item details
        // and check the new status
        manageItemDetail.get({id: $scope.itemDetail._id},
          function (resource) {
            if (!!resource && !!resource.content && !!resource.content.data &&
                !!resource.content.data.import_status) {

              var importStatus = resource.content.data.import_status;
              //Store item Import id to fadeout on approved table
              HighlightId.setId($scope.itemDetail._id);
              $state.go('main.user.items.manageCatalog', { status: importStatus.toLowerCase() });
            } else {
              $state.go('main.user.items.manageCatalog', {status: 'pending'});
            }
          },
          function () {
            //Store catalog id to fadeout on pending table
            HighlightId.setId($scope.itemDetail._id);
            $state.go('main.user.items.manageCatalog', {status: 'pending'});
          }
        );

      }, function () {
        toastr.error('Catalog cannot be approved.');
      }
    );
  }

  // Reject Item
  function rejectItem() {
    swal({
        title: 'Confirm reject item?',
        text: 'This item will be rejected by you. Please write a reason',
        type: 'input',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: false,
        closeOnCancel: true,
        inputType: 'text',
        inputPlaceholder: 'Write a reason'
      },
      function(inputValue) {
        if(!!inputValue){
          var trimmedValue = inputValue.trim();
        }

        if (!inputValue) {
          swal.showInputError('You need to write a reason for rejecting!');
          return false;
        }

        if(trimmedValue === '') {
          swal.showInputError('You need to write a reason for rejecting!');
          return false
        }
        items.approve(
          {
            approval_id: $scope.itemDetail.approval_id,
            status: 'reject'
          },
          {
            comment: inputValue
          },
          function () {
            toastr.success('Rejected catalog');

            // Get the item details
            // and check the new status
            manageItemDetail.get({id: $scope.itemDetail._id},
              function (resource) {
                swal.close();
                if (!!resource && !!resource.content && !!resource.content.data &&
                  !!resource.content.data.import_status) {

                  //Store Item Import id to fadeout on approved table
                  HighlightId.setId($scope.itemDetail._id);

                  if (resource.content.data.import_status === 'APPROVED') {
                    $state.go('main.user.items.manageCatalog', {status: 'approved'});
                  } else if (resource.content.data.import_status === 'PENDING') {
                    $state.go('main.user.items.manageCatalog', {status: 'pending'});
                  } else {
                    $state.go('main.user.items.manageCatalog', {status: 'rejected'});
                  }
                } else {
                  $state.go('main.user.items.manageCatalog', {status: 'pending'});
                }
              },
              function (error) {
                //Store catalog id to fadeout on pending table
                HighlightId.setId($scope.itemDetail._id);
                $state.go('main.user.items.manageCatalog', {status: 'pending'});
              }
            );
          }, function (error) {
            toastr.error('Catalog cannot be rejected.');
          }
        );
    });
  }

  function initialize(){

    $state.params.status = !!$scope.itemDetail.import_status ? $scope.itemDetail.import_status.toLowerCase() : 'all';

    var tabData = {
      tab: $scope.$parent.tabData[0],
      noTransition: true
    };
    $rootScope.$broadcast('loadSpecificTab', tabData);
  }

  initialize();

}

itemDetailCtrl.$inject = ['$scope', 'toastr', 'managedItem', '$q', '$stateParams', '$state',
                          'catalogVersion', 'downloadFile', '$filter', 'pathConstants', '$http',
                          '$uibModal', 'changeStatusCatalog', 'Approvals', 'profile',
                          'items', 'manageItemDetail', 'HighlightId', 'itemDetailsListing',
                          '$rootScope', 'searchModule', 'globalFunc'];

angular.module('metabuyer')
  .controller('itemDetailCtrl', itemDetailCtrl);
